export const MAX_FILE_SIZE = 10 * 1024 * 1024
export const MAX_FILE_NUM = 5
